const AI_MODELS_URL = '/ai-models';

/**
 * https://blueprint.bukalapak.io/t/mlplatform~mlplatform~online~model~serving~post~ai-models~aichan~invocations
 * @param {object[]} body - [{ message: <string> }, ...]
 * @returns {Promise}
 */
export const postChatTextAndGetIntents = ($axios, body = []) =>
  $axios.$post(`${AI_MODELS_URL}/aichan/invocations`, body);

/**
 * Validate KTP for Change Phone Number flow
 * https://blueprint.bukalapak.io/t/mlplatform~mlplatform~online~model~serving~post~ai-models~simkyc~invocations
 * @param {object[]} body - [{ image_base64: <string> }, ...]
 * @returns {Promise}
 */
export const validateKtp = ($axios, body = []) => $axios.$post(`${AI_MODELS_URL}/simkyc/invocations`, body);

/**
 * Validate Selfie for Change Phone Number flow
 * https://blueprint.bukalapak.io/t/mlplatform~mlplatform~online~model~serving~post~ai-models~selfiekyc~invocations
 * @param {object[]} body - [{ image_base64: <string> }, ...]
 * @returns {Promise}
 */
export const validateSelfie = ($axios, body = []) => $axios.$post(`${AI_MODELS_URL}/selfiekyc/invocations`, body);

/**
 * Classifies document type and checks clarity of the supporting document
 * https://blueprint.bukalapak.io/t/mlplatform~mlplatform~online~model~serving~post~ai-models~docufy~invocations
 * @param {object[]} body - [{ image_base64: <string> }, ...]
 * @returns {Promise}
 */
export const validateSupportingDocument = ($axios, body = []) =>
  $axios.$post(`${AI_MODELS_URL}/docufy/invocations`, body);
